/**
 * Created by alex.shmaltsuev on 2016-03-31.
 */
import { createAction } from 'redux-actions'
import C from  '../constants/auth';
import { axiosInstance } from '../utils/helpers';
import C_USER from  '../constants/user';
// import {reportData} from '../utils/helpers';


const intervalTime =  900 * 1000;
export const login = createAction('login');
export const logout = createAction('logout');

function keepAlive(state) {
	let timeStamp = new Date().getTime();
	axiosInstance.get(
		`KeepAlive.jsp?stamp=${timeStamp}&notAddingIndexJSP=true&ssp=true`
	).then((response) => {
		let isLoggedIn = response.data.login;
		if (isLoggedIn === 'true' && !state.auth.get('logedIn')) {

			let LoggedUserName = state.user.get(C_USER.USER_NAME);
			let currentUserName = response.data.username;
			if(LoggedUserName != currentUserName){
				window.location.reload(true);
			} else {
                login();
			}

		} else if (isLoggedIn === 'false') {
            // reportData('keepAlive', 'End Of Session', window.location.pathname);
			logout();
			window.location = '/Login.jsp';
		}
	});
}

export function keepAliveInterval() {
    return function (dispatch, getState) {
        let keepAliveInterval = getState().auth.get('keepAliveInterval');
        if (!keepAliveInterval) {
            dispatch({
                'type': C.KEEP_ALIVE
            });
            setInterval(()=>keepAlive(getState()), intervalTime);
        }
    }
}


// WEBPACK FOOTER //
// ./actions/auth.js